export default __webpack_public_path__ + "static/media/purple.e334931d.svg";